import { collection, doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const compactValue = (value) => {
  if (value === undefined) return null;
  if (value === null) return null;
  if (value instanceof Date) return value.toISOString();
  if (value?.toDate) {
    try { return value.toDate().toISOString(); } catch (_) { return String(value); }
  }
  if (Array.isArray(value)) return value.slice(0, 30).map(compactValue);
  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([key]) => !["ref", "__date", "__fee"].includes(key))
        .slice(0, 40)
        .map(([key, nested]) => [key, compactValue(nested)])
    );
  }
  if (typeof value === "string") return value.slice(0, 500);
  return value;
};

export const writeAuditLog = async ({
  user,
  action,
  entityType,
  entityId = "",
  title = "",
  before = null,
  after = null,
  meta = {},
}) => {
  if (!user?.uid || !action || !entityType) return;

  const ref = doc(collection(db, "audit-logs"));
  await setDoc(ref, {
    action,
    entityType,
    entityId: String(entityId || ""),
    title: String(title || ""),
    actorUid: user.uid,
    actorEmail: user.email || "",
    actorName: user.displayName || "",
    before: compactValue(before),
    after: compactValue(after),
    meta: compactValue(meta),
    createdAt: serverTimestamp(),
  });
};
